module.exports = __webpack_public_path__ + "img/cwell8.d466de35.jpg";